import { Button } from '@ksyos/design-system';
import type { EpisodeCategory, ServiceCode, ServiceType } from '@common/enums';
import type { IEpisodeCategoryOneService, IServiceTypeWithOneService } from '@common/interfaces';

interface INewProcessButtonProps {
    automation: string;
    data: IServiceTypeWithOneService | IEpisodeCategoryOneService | { name: ServiceCode.OrthO | ServiceCode.OrthOFol };
    name: string;
    onClick: (name: any) => void;
    previousSelection: ServiceCode | ServiceType | EpisodeCategory | undefined;
    scrollToBottom?: () => void;
}

export function NewProcessButton(props: INewProcessButtonProps) {
    const { automation, data, name, onClick, previousSelection, scrollToBottom } = props;

    return (
        <Button
            className={`automation-${automation}`}
            color="secondary"
            data-automation-test={automation}
            key={data.name}
            onClick={async () => {
                await onClick(data.name);
                if (scrollToBottom) {
                    scrollToBottom();
                }
            }}
            variant={data.name !== previousSelection ? 'outline' : 'solid'}
        >
            {name}
        </Button>
    );
}
